import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useClosePopup } from '../../../utils/hooks/usePopup';
import Popup from '../../Popup';
import Button from '../../../elements/Button';
import sha256 from 'sha256';
import API from '../../../utils/api/API';
import Users from '../../../utils/api/Users';
import PNTrading from 'src/pn-trading-sdk';

export default function DeleteTrustee({ customer, trustee, onDeleted }) {
	let history = useHistory();
	const close = useClosePopup();

	const confirm = async () => {
		// Delete the trustee.
		await PNTrading.request(
			`/customers/${customer}/trustees/${trustee}`,
			{},
			{
				method: 'DELETE',
			}
		);

		onDeleted && onDeleted();

		close();
	};

	return (
		<Popup close={close} width="40em" maxWidth="25em">
			<Style>
				<h2 className="title">Ta bort förvaltare</h2>
				<div className="spacer s"></div>
				<p>Denna förvaltare samt all data kommer att tas bort permanent, åtgärden kan inte ångras, är du säker?</p>

				<div className="spacer xs"></div>

				<div className="buttons">
					<Button type="secondary" onClick={close}>
						Avbryt
					</Button>
					<Button onClick={confirm}>Ja, ta bort</Button>
				</div>
			</Style>
		</Popup>
	);
}

const Style = styled.div``;
